import React, { useState } from 'react';
import styled from 'styled-components';

import Form from './Form';


const CloseFloater = styled.a`
    cursor:pointer
`

const FormLabel = styled.label`
    display:block;
`
const FormTextArea = styled.textarea`
    display:block;
    padding:5px;
`
const FormInput = styled.input`
    display:block;
    padding:5px;
`
const FormItem = styled.div`
    display:block;
    margin-bottom:20px;
`

const Selector = styled.select`
    display:block;
    padding:5px;
`
function ContactFloater() {
    const [showFloater, setShowFloater] = useState(false);

    const ShowForm = function () {
        console.log("show form");
        setShowFloater(true)
    }


    const closeFloater = function () {
        console.log("dsdsd");
        setShowFloater(false)
    }

    return (
        <div className="contactFloater">
            <CloseFloater className={showFloater ? "opened" : "closed"} onClick={closeFloater} id="closeFloater">"[X]" Close</CloseFloater>
            <a id="openFloater" onClick={ShowForm}>
                Contact Me
            </a>

            <div className={showFloater ? "opened" : "closed"}>
                <Form className="lel"></Form>
            </div>

        </div>
    )
}

export default ContactFloater;
